module.exports = __webpack_public_path__ + "img/Nepal.97461727.png";